import { observer } from "mobx-react-lite";
import { ReactComponent as Filter } from '../../images/icons/filter.svg';
import { ReactComponent as Find } from '../../images/icons/find.svg';
import { ReactComponent as Plus } from '../../images/icons/plus.svg';
import { useContext, useEffect } from "react";
import { Context } from "../..";

const PositionList = ({ name, summ, summTax, onCreate, children }) => {
    const { store } = useContext(Context);

    return (
        <li>
            <div className="title">
                <div className="text">{name}</div>
                <div className="management">
                    {/* <div className="summ">
                        <div className="text">Итого:</div>
                        <div className="value">{summ ? summ : 0} ₽</div>
                    </div> */}
                </div>
            </div>
            <div className="content">
                <div className="managementLine">
                    <div className="leftSide"></div>
                    <div className="rightSide">
                        <button className="defaultButton disabled"><Filter/></button>
                        <button className="defaultButton disabled"><Find/></button>
                        { store.userInfo && store.userInfo.isLicensed == true && <button className="activeButton" onClick={(event) => onCreate()}>Добавить <Plus/></button> }
                    </div>
                </div>
                <div className="tableHeader">
                    <div className="left">
                        <div className="num">№ п/п</div>
                        <div className="name">Наименование</div>
                    </div>
                    <div className="right">
                        <div>Количество ставок:</div>
                        <div>ФОТ:</div>
                        <div>Взносы с ФОТ:</div>
                        <div>Раскрыть/удалить</div>
                    </div>
                </div>
                <ul className="positionsList">{children}</ul>
            </div>
            <div className="summ">
                <div className="title">Итого:</div>
                <div className="value">
                    <div className="title">ФОТ:</div>
                    <div>{summ}</div>
                </div>
                <div className="value">
                    <div className="title">Взносы с ФОТ:</div>
                    <div>{summTax}</div>
                </div>
            </div>
        </li>
    );
}

export default observer(PositionList);
